// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-progress-bar[data-v-053e9ae1]{min-width:200px;max-width:300px}.upload-progress-bar .progress-text[data-v-053e9ae1]{display:block;font-size:.8em;color:var(--color-text-maxcontrast);margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.upload-progress-bar[data-v-053e9ae1] .progress-bar{height:4px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
